<template>
  <div class="col-sm-12 col-lg-6 col-md-6">
    <div style="text-align: center" v-if="TotalsItems.length > 0">
      <label
        >Totals
        <a href="/admin-points-faq" target="_blank">
          <font-awesome-icon icon="question-circle" />
        </a>
      </label>

      <b-table
        class="table table-hover table-responsive table-bordered my-1"
        responsive="sm"
        sort-icon-right
        style="width: 100%"
        hover
        :fields="TotalsFields"
        :items="TotalsItems"
      >
        <template v-slot:cell(total)="data">
          <p class="mr-2">
            {{ parseInt(data.item.total).toLocaleString() }}
          </p>
        </template>
      </b-table>
    </div>
    <div
      style="text-align: center"
      v-if="TotalsItems.length > 0 && AddPointPrograms.length > 0"
    >
      <label
        >Add Points Actions
        <a href="/admin-points-faq" target="_blank">
          <font-awesome-icon icon="question-circle" />
        </a>
      </label>

      <p>For Programs</p>
      <b-table
        class="table table-hover table-responsive table-bordered my-1"
        responsive="sm"
        sort-icon-right
        style="width: 100%"
        hover
        :fields="AddPointProgramsFields"
        :items="AddPointPrograms"
      >
        <template v-slot:cell(users)="data">
          <p>{{ parseInt(data.item.users).toLocaleString() }}</p>
        </template>
        <template v-slot:cell(pending_points)="data">
          <p class="mr-2">
            {{ parseInt(data.item.pending_points).toLocaleString() }}
          </p>
        </template>
      </b-table>
    </div>
    <div class="row my-1" v-if="checkModuleInSummary('Update: Add points')">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Add Points To Users
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <label class="my-2">Update: Add Points Records</label>
        <p>
          These
          {{
            parseInt(
              checkModuleInSummaryReturnWithPoints("Update: Add points")
            ).toLocaleString()
          }}
          updates are Points additions to existing users. You can process all of
          these records at once if you wish and the default program parameters
          will be used to generate an email message to the user as follows:
        </p>
        <ul>
          <li>
            If you have entered an email message and email subject on the row
            for that user (see column help in the FAQ for details), then that
            message is used.
          </li>
          <li>
            If you have not entered an individual message but you have entered a
            program message using the form below, then the message from the form
            below is used.
          </li>
          <li>
            If you have not entered an individual message nor have you entered a
            new program message using the form below, then the default message
            for the program is used (the message setup when the program was
            created).
          </li>
        </ul>
        <p>
          Remember, if you wish to generate a more specific email use the
          <i>Program points</i> fields below and choose the program parameters
          if needed.
        </p>
        <b-button
          class="btn-lg btn-sm-block m-2"
          pill
          variant="primary"
          @click="updateBatchUsersWithAllPoints()"
          >Process all 'adds'
        </b-button>
        <b-button
          class="btn-lg btn-sm-block m-2"
          pill
          variant="primary"
          :to="{
            name: 'AdminBatchUserUploadToolUpdatePoints',
            params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
          }"
          >Preview</b-button
        >
      </div>
    </div>
    <div
      class="row my-1"
      v-if="TotalsItems.length > 0 && AddPointPrograms.length > 0"
    >
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Manage Points Per Program
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <p class="mt-3">
          One or more points additions are tied to a program for this import.
          Programs allow you to more closely monitor the ROI of your incentive
          program by tying awards to a specific emphasis. When program points
          are awarded, that award is reflected in the transaction reports.
        </p>
        <p>
          You have the option of sending an email message for program points as
          well. You can use the fields below to send such a message to your
          program participants who have earned points. If you leave the fields
          blank the default message will be sent.
        </p>
        <div
          class="col-sm-12 col-lg-12 col-md-12 border p-3"
          v-for="Point in AddPointPrograms"
          :key="Point.program_id"
        >
          <label>Add program points</label>
          <br />
          <label
            >Program: <i>{{ Point.program_name }}</i></label
          >
          <b-form
            @submit="
              (event) => {
                event.preventDefault();
                updateBatchUsersWithPoints(AllClientForm[Point.program_id]);
              }
            "
          >
            <label for="EMAIL_SUBJECT">subject:</label>
            <b-form-input
              id="EMAIL_SUBJECT"
              required
              v-model="AllClientForm[Point.program_id].EMAIL_SUBJECT"
            >
            </b-form-input>
            <label for="EMAIL_MESSAGE">message:</label>
            <b-form-textarea
              id="EMAIL_MESSAGE"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
              v-model="AllClientForm[Point.program_id].EMAIL_MESSAGE"
            ></b-form-textarea>
            <b-button class="m-2" pill variant="primary" type="submit"
              >Add Points</b-button
            >
            <b-button
              class="m-2"
              pill
              variant="primary"
              :to="{
                name: 'AdminBatchUserUploadToolUpdatePoints',
                params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
              }"
              >Preview</b-button
            >
          </b-form>
        </div>
      </div>
    </div>
    <div class="row my-1" v-if="checkModuleInSummary('edit')">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Edit Records - Missing Data
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <label class="my-2">Edit Records</label>
        <p>
          These
          {{
            parseInt(
              checkModuleInSummaryReturnWithPoints("edit")
            ).toLocaleString()
          }}
          records need editing because a required data item is missing. Required
          fields are Username, Firstname, Lastname, and either Company_id or
          Company_name. See the online help if you need assistance determining
          the right company name or ID.
        </p>

        <b-button
          class="btn-lg btn-sm-block m-2"
          :to="{
            name: 'AdminBatchUserUploadToolEditRecords',
            params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
          }"
          pill
          variant="primary"
          >Edit</b-button
        >
      </div>
    </div>
    <div class="row my-1" v-if="checkModuleInSummary('insert')">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Insert New Users
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <label class="my-2">Insert records</label>
        <p>
          These
          {{ checkModuleInSummaryReturnWithPoints("insert") }} records meet the
          criteria and they are ready to be inserted as new users.
        </p>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          @click="insertFinalUsers()"
        >
          Insert
        </b-button>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          :to="{
            name: 'AdminBatchUserUploadToolPreviewInsertUsers',
            params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
          }"
        >
          Preview
        </b-button>
      </div>
    </div>
    <div class="row my-1" v-if="checkModuleInSummary('Update: Information')">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Update Existing Users
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <label class="my-2">Update: Information Records</label>
        <p>
          These
          {{
            parseInt(
              checkModuleInSummaryReturnWithPoints("Update: Information")
            ).toLocaleString()
          }}
          are updates of existing users. These records will update user
          information but are not set up to add or delete points.
        </p>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          @click="updateExistingUserInformation()"
        >
          Update: Information
        </b-button>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          :to="{
            name: 'AdminBatchUserUploadToolUpdateInformation',
            params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
          }"
        >
          Preview
        </b-button>
      </div>
    </div>
    <div class="row my-1" v-if="countUpdateDeletePoints() > 0">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Delete Points from Users
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />

        <label class="my-2">Update Delete Points records</label>
        <p>
          These
          {{
            parseInt(
              checkModuleInSummaryReturnWithPoints(
                "Update: Delete points"
              ).toLocaleString()
            )
          }}
          updates are slated to take points away from existing users. If this is
          an administrative adjustment, it is good idea to user the email_msg
          field to help keep the user informed of their account information.
        </p>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          @click="updateBatchUsersWithDeletePoints"
        >
          Update Delete Points
        </b-button>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block m-2"
          :to="{
            name: 'AdminBatchUserUploadToolDeletePoints',
            params: {previousRoute: previousRoute, activeMenuItem: activeMenuItem}
          }"
        >
          Preview
        </b-button>
      </div>
    </div>
    <div class="row my-1" v-if="countDeletePendingChanges() > 0">
      <div class="col-sm-12 col-lg-12 col-md-12 border p-3">
        <label
          >Delete Pending Changes
          <a href="/admin-points-faq" target="_blank">
            <font-awesome-icon icon="question-circle" />
          </a>
        </label>
        <br />
        <label class="my-2">Delete </label>
        <p>
          All
          {{ parseInt(countDeletePendingChanges()).toLocaleString() }}
          previous records without changes.
        </p>

        <b-button
          @click="deleteAllPendingRecords()"
          variant="primary"
          class="btn-lg btn-sm-block m-2"
        >
          Delete Pending
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
    props: {
    previousRoute: String,
    activeMenuItem: String
  },
  data() {
    return {
      checkSummaryString: "Check the user manager or transaction report to make sure the results are what you intended.",
      TotalsFields: [
        {
          key: "action",
        },
        {
          key: "status",
        },
        {
          key: "total",
          tdClass: "text-right",
        },
      ],
      TotalsItems: [],
      PointActionsFields: [
        {
          key: "program",
        },
        {
          key: "users",
          tdClass: "text-right",
        },
        {
          key: "pending_points",
          tdClass: "text-right",
        },
      ],
      AddPointProgramsFields: [
        {
          key: "program_name",
        },
        {
          key: "total",
          tdClass: "text-right",
        },
        {
          key: "totalPoints",
          tdClass: "text-right",
        },
      ],
      AddPointPrograms: [],
      AllClientsProgram: [],
      AllClientForm: {},
    };
  },
  components: {
    appModal: Modal,
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    getFormUsers() {
      const programs = this.$store.getters["adminBatchUserUploadTool/getUsersPrograms"];

      if (programs) {
        this.AllClientForm = programs.reduce(
          (
            currentValue,
            { program_id, program_name, total, totalPoints, actiontype }
          ) => {
            return {
              ...currentValue,
              [program_id]: {
                EMAIL_MESSAGE: "",
                EMAIL_MESSAGE: "",
                PROGRAM_ID: program_id,
                PROGRAM_NAME: program_name,
              },
            };
          },
          {}
        );
        this.AddPointPrograms = programs.filter(
          (prgm) => prgm.actiontype === "Update: Add points"
        );
      } else this.AllClientsProgram = {};
    },
    checkModuleInSummary(moduleString) {
      if (this.getAllBatchUsersSummary) {
        var flag = false;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          if (this.getAllBatchUsersSummary[i].actionType === moduleString) {
            flag = true;
            break;
          }
        }
        return flag;
      }
    },
    checkModuleInSummaryReturnWithPoints(moduleString) {
      if (this.getAllBatchUsersSummary) {
        var point = 0;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          if (this.getAllBatchUsersSummary[i].actionType === moduleString) {
            point = this.getAllBatchUsersSummary[i].total;
            break;
          }
        }
        console.log(moduleString, point);
        return point;
      }
    },
    countDeletePendingChanges() {
      if (this.getAllBatchUsersSummary) {
        var point = 0;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          point += this.getAllBatchUsersSummary[i].total;
        }
        return point;
      }
    },
    checkModuleInSummaryReturnWithPoints(moduleString) {
      if (this.getAllBatchUsersSummary) {
        var point = 0;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          if (this.getAllBatchUsersSummary[i].actionType === moduleString) {
            point = this.getAllBatchUsersSummary[i].total;
            break;
          }
        }
        return point;
      }
    },
    countUpdateDeletePoints() {
      console.log(this.getAllBatchUsersSummary);
      if (this.getAllBatchUsersSummary) {
        var point = 0;
        for (var i = 0; i < this.getAllBatchUsersSummary.length; i++) {
          if (
            this.getAllBatchUsersSummary[i].actionType ===
            "Update: Delete points"
          ) {
            point++;
          }
        }
        return point;
      }
    },
    updateExistingUserInformation() {
      this.$store
        .dispatch("adminBatchUserUploadTool/updateExistingUserInformation")
        .then((status) => {
          if (status === 200) {
            // summary update
            this.$store.dispatch(
              "adminBatchUserUploadTool/fetchUserUploadSummary"
            );

            // scrolling to top
            this.scrollToTop();
            this.getFormUsers();

            // open modal, show message
            this.$store.dispatch("systemMessage/setModalMessage", {
              message:
                `Your users have been updated. ${this.checkSummaryString}`,
            });
          }
        })
        .catch(() => {
          console.log("error from update existing user information");
        });
    },
    updateBatchUsersWithDeletePoints() {
      this.$store
        .dispatch("adminBatchUserUploadTool/updateBatchUsersWithDeletePoints")
        .then((status) => {
          if (status === 200) {
            this.scrollToTop();
            this.$store.dispatch(
              "adminBatchUserUploadTool/fetchUserUploadSummary"
            );
            this.getFormUsers();

            this.$store.dispatch("systemMessage/setModalMessage", {
              message:
                `Your users have been updated. ${this.checkSummaryString}`,
            });
          }
        })
        .catch((err) => {
          console.error("Error occured while updating users.");
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: err || "Error occured while updating users.",
          });
        });
    },
    updateBatchUsersWithAllPoints() {
      this.$store
        .dispatch("adminBatchUserUploadTool/updateBatchUsersWithAllPoints")
        .then((status) => {
          if (status === 200) {
            this.scrollToTop();
            this.$store.dispatch(
              "adminBatchUserUploadTool/fetchUserUploadSummary"
            );
            this.getFormUsers();
            this.$store.dispatch("systemMessage/setModalMessage", {
              message:
                `Your users have been updated. ${this.checkSummaryString}`,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: err || "Error occured while updating users.",
          });
        });
    },
    deleteAllPendingRecords() {
      this.$store
        .dispatch("adminBatchUserUploadTool/removeAllPendingRecords")
        .then((status) => {
          // summary update
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );
          this.getFormUsers();
          // scrolling to top
          this.scrollToTop();

          // open modal, show message
          this.$store.dispatch("systemMessage/setModalMessage", {
            message:
              "All pending records have been deleted without being finalized.",
          });
        })
        .catch(() => {
          console.log("error while insert final users batch user upload");
        });
    },
    updateBatchUsersWithPoints(payload) {
      this.$store
        .dispatch(
          "adminBatchUserUploadTool/updateBatchUsersWithPoints",
          payload
        )
        .then((status) => {
          if (status === 200) {
            this.scrollToTop();
            this.$store.dispatch(
              "adminBatchUserUploadTool/fetchUserUploadSummary"
            );
            this.getFormUsers();

            this.$store.dispatch("systemMessage/setModalMessage", {
              message:
                 `Your users have been updated. ${this.checkSummaryString}`,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("systemMessage/setModalMessage", {
            message: err || "Error occured while updating users.",
          });
        });
    },
    insertFinalUsers() {
      this.$store
        .dispatch("adminBatchUserUploadTool/insertFinalUserRecords")
        .then((status) => {
          // summary update
          this.$store.dispatch(
            "adminBatchUserUploadTool/fetchUserUploadSummary"
          );

          // scrolling to top
          this.scrollToTop();
          this.getFormUsers();

          // open modal, show message
          this.$store.dispatch("systemMessage/setModalMessage", {
            message:
              `Your insert data has been finalized. ${this.checkSummaryString}`,
          });
        })
        .catch(() => {
          console.error("error while insert final users batch user upload");
        });
    },
  },
  computed: {
    getAllBatchUsersSummary() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllBatchUserSummary"
      ];
    },
  },
  watch: {
    getAllBatchUsersSummary(getAllBatchUsersSummary) {
      var datas = getAllBatchUsersSummary.map(function (data) {
        return {
          action: data.actionType[0].toUpperCase() + data.actionType.slice(1),
          status: data.status[0].toUpperCase() + data.status.slice(1),
          total: data.total,
        };
      });

      this.TotalsItems = datas;
    },
  },
};
</script>